import { redirect } from "react-router-dom";
import { DOCUMENT_POST_API, 
         DOCUMENT_PATCH_API, 
         DOCUMENT_DELETE_API } from '../../constants/apis';
import { DOCUMENT_LIST_PATH, LOGIN_PATH } from '../../constants/paths';
import { postModel, patchModel, deleteModel } from '../../utils/functions';
import { DEFAULT_UNKNOWN_ERROR_MESSAGE } from '../../constants/constants';


export async function documentAction({ params, request }) {
    const requestData = await request.json();

    let data;

    if (requestData !== null) {
        if (requestData.resetWarnings) {        
            return {
                message: "",
                parameters: []
            };
        }
    
        data = requestData.data;
    }    

    try {
        switch (request.method) {
            case "POST":
                await postModel(DOCUMENT_POST_API, data);

                return redirect(DOCUMENT_LIST_PATH);
            case "PATCH":
                await patchModel(`${DOCUMENT_PATCH_API}${params.document_id}`, data);

                return redirect(DOCUMENT_LIST_PATH);
            case "DELETE":
                await deleteModel(`${DOCUMENT_DELETE_API}${params.document_id}`);
                
                return redirect(DOCUMENT_LIST_PATH);
            default:
                return {
                    message: "Esta página possui erros de implementação/desenvolvimento.",
                    parameters: []
                };
        }
    }
    catch(errors) {
        let message = [];
        let parameters = [];

        if(errors instanceof Array) {
            for(let error of errors) {
                if(error.code === 103) {
                    for(let parameter of error.parameters) {
                        if(parameter.name === 'name') {
                            message.push('Nome já cadastrado');
                            parameters.push('name');
                        }
                    }
                }
                else if(error.code === 208) {
                    if(error.message.includes('Document id might be invalid')) {
                        message.push('Documento não encontrado');
                    }
                }
                else if(error.code === 209) {
                    // message.push('Sessão do usuário expirada');
                    return redirect(LOGIN_PATH);
                }
            }
        }

        if (message.length <= 0) {
            message = [DEFAULT_UNKNOWN_ERROR_MESSAGE];
        }
    
        return {
            parameters,
            message: `${message.join('; ')}.`
        };
    }
  };